import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import useEventsAndLocations from '$src/hooks/useEventsAndLocations';
import { EventIcon, MonitoringStationIcon } from '@ring-icons';
import TabContentsEventList from './TabContentsEventList';

import './index.less';

function ListEventsCard({ locationSelected, locations }) {
  const currentLocationOwnerIds = useMemo(() => locationSelected ? [locationSelected.ownerId] : [...new Set(locations?.map(l => l.ownerId))], [locationSelected, locations]); 
  const {
    eventsLocations,
    emergenciesLocations,
    loadingEventsLocations,
    fetchNextPageOfEvents,
    fetchNextPageOfEmergencies,
    filterEventsByResolutionTypes,
    filterEmergenciesByResolutionTypes,
  } = useEventsAndLocations(currentLocationOwnerIds, locationSelected?.locationId, locations);

  const onScrollListEventCard = (onBottom) => {
    if (onBottom && Object.keys(eventsLocations?.nextToken).length) {
      fetchNextPageOfEvents(currentLocationOwnerIds, locationSelected?.locationId, eventsLocations?.nextToken);
    }
  }; 
  
  const onScrollListEmergencyCard = (onBottom) => {    
    if (onBottom && Object.keys(emergenciesLocations?.nextToken).length) {
      fetchNextPageOfEmergencies(currentLocationOwnerIds, locationSelected?.locationId, emergenciesLocations?.nextToken);
    }
  };

  const onFilterEventChange = (eventType) => {
    filterEventsByResolutionTypes(eventType);
  };

  const onFilterEmergencyChange = (eventType) => {
    filterEmergenciesByResolutionTypes(eventType);
  };

  return (
    <Tabs
      items={[
        {
          key: '1',
          label: 'Events',
          children: (
            <TabContentsEventList
              icon={EventIcon}
              data={eventsLocations?.items}
              total={eventsLocations?.count}
              onScroll={onScrollListEventCard}
              onFilterEventChange={onFilterEventChange}
              loading={loadingEventsLocations}
            />
          ),
        },
        {
          key: '2',
          label: 'Emergencies',
          children: (
            <TabContentsEventList
              icon={MonitoringStationIcon}
              data={emergenciesLocations?.items}
              total={emergenciesLocations?.count}
              onFilterEventChange={onFilterEmergencyChange}
              onlyEmergencies
              onScroll={onScrollListEmergencyCard}
              loading={loadingEventsLocations}
            />
          ),
        },
      ]}
      data-testid="list-events-card"
      className="list-events-card"
    />
  );
}

ListEventsCard.propTypes = {
  locationSelected: PropTypes.object,
  locations: PropTypes.array,
};

export default ListEventsCard;
